import React, { forwardRef, MouseEvent, useMemo } from 'react';
import { Top10Selection, SelectionMovie } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { Route } from '@funtech-int/rival';
import { useInView } from 'react-intersection-observer';

import { Carousel } from '../Carousel/Carousel';
import * as Card from '../Card';
import { mergeRefs } from '../../lib/ref';

import { SelectionTitle } from './_SelectionTitle';
import styles from './_Top10.module.css';

interface Top10Props {
    selection: Top10Selection;
    movieRoute: Route<any, { id: string }, any>;
    className?: string;
    onCardShow?(item: SelectionMovie, index: number): void;
    onCardClick?(item: SelectionMovie, index: number): void;
}

export const Top10 = forwardRef<HTMLDivElement, Top10Props>(
    ({ selection, movieRoute, className, onCardShow, onCardClick }, ref) => {
        const { ref: inViewRef, inView } = useInView({
            threshold: 0.8,
        });

        const mergedRef = useMemo(
            () => mergeRefs<HTMLDivElement>(ref, inViewRef),
            [ref, inViewRef]
        );

        return (
            <div ref={mergedRef} className={className} data-tid="Top10Selection">
                {selection.title ? (
                    <SelectionTitle
                        title={
                            <div className={styles.row}>
                                <div className={styles.logoTop10} aria-hidden />
                                <div className={styles.title}>{selection.title}</div>
                            </div>
                        }
                    />
                ) : null}
                <Carousel className={styles.carousel}>
                    {selection.items.map((item, index) => {
                        const handleCardShow = () => {
                            onCardShow?.(item, index);
                        };

                        const handleCardClick = (e: MouseEvent<HTMLAnchorElement>) => {
                            e.preventDefault();
                            onCardClick?.(item, index);
                        };

                        return (
                            <Card.Top10
                                key={item.contentId}
                                movie={item}
                                position={index}
                                location={movieRoute({ id: item.contentId })}
                                isHighlighted={inView}
                                onShow={handleCardShow}
                                onClick={handleCardClick}
                            />
                        );
                    })}
                </Carousel>
            </div>
        );
    }
);
